/**
 * Generated by orval v8.8.0 🍺
 * Do not edit manually.
 * 4emp.app API
 * API для управления турнирами по разным видам спорта
 * OpenAPI spec version: 1.0.0
 */
import type {
  ActionResult,
  AuthEmailConfirmRequest,
  AuthEmailConfirmResponse,
  AuthEmailRequest,
  AuthLogoutRequest,
  AuthRefreshRequest,
  AuthTokensResponse,
  AuthWebAuthnCredential,
  AuthWebAuthnCredentialRename,
  AuthWebAuthnFinishRequest,
  AuthWebAuthnLoginBeginRequest,
  AuthWebAuthnOptions,
  Bracket,
  FieldValues,
  GetApiV1HomeParams,
  GetApiV1MatchesParams,
  GetApiV1OfficialsParams,
  GetApiV1OrganizationsOrganizationIdTournamentsParams,
  GetApiV1OrganizationsParams,
  GetApiV1PlayersParams,
  GetApiV1PlayersPlayerIdStatsParams,
  GetApiV1RegistrationsParams,
  GetApiV1TeamsParams,
  GetApiV1TournamentPresetsParams,
  GetApiV1TournamentsParams,
  GetApiV1TournamentsTournamentIdLeaderboardsPlayersParams,
  GetApiV1TournamentsTournamentIdMatchesParams,
  GetApiV1TournamentsTournamentIdPlayerStatsParams,
  GetApiV1TournamentsTournamentIdRegistrationsParams,
  GetApiV1TournamentsTournamentIdStandingsParams,
  GetApiV1VenuesParams,
  HomeFavorites,
  HomeResponse,
  LeaderboardPlayers,
  ManagerResponse,
  Match,
  MatchCreate,
  MatchEvent,
  MatchEventCreate,
  MatchEventList,
  MatchEventUpdate,
  MatchLiveConfig,
  MatchResultReport,
  MatchUpdate,
  MePlayer,
  NotificationSettings,
  Official,
  OfficialCreate,
  OfficialUpdate,
  Organization,
  OrganizationCreate,
  OrganizationUpdate,
  PaginatedMatchesResponse,
  PaginatedOfficialsResponse,
  PaginatedOrganizationsResponse,
  PaginatedPlayerStatsList,
  PaginatedPlayersResponse,
  PaginatedRegistrationsResponse,
  PaginatedTeamsResponse,
  PaginatedTournamentsResponse,
  PaginatedVenuesResponse,
  Player,
  PlayerCreate,
  PlayerStatsSummary,
  PlayerUpdate,
  PostApiV1AuthWebauthnRegisterBeginBody,
  PostApiV1TournamentsTournamentIdSeedBody,
  PushSubscriptionDeleteRequest,
  PushSubscriptionRequest,
  Registration,
  RegistrationCreate,
  RegistrationUpdate,
  ScheduleGenerationRequest,
  ScheduleGenerationResponse,
  SchedulePreviewResponse,
  ScheduleSaveRequest,
  SettingsForm,
  Sport,
  SportCreate,
  SportUpdate,
  StageStandingTable,
  StandingTable,
  Team,
  TeamCreate,
  TeamUpdate,
  Tournament,
  TournamentCreate,
  TournamentPreset,
  TournamentResults,
  TournamentStage,
  TournamentStageCreate,
  TournamentStageUpdate,
  TournamentUpdate,
  TournamentWorkflow,
  Venue,
  VenueCreate,
  VenueUpdate,
  WebPushConfig
} from './model';

import { customInstance } from '../mutator/customInstance';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const get4empAppAPI = () => {
/**
 * Данные для сборки главной: матчи на период, популярные турниры, при авторизации — избранное и «моё участие».
Без Bearer возвращаются только публичные блоки (matchesUpcoming, popularTournaments, calendarDays).

 * @summary Главная страница
 */
const getApiV1Home = (
    params?: GetApiV1HomeParams,
 options?: SecondParameter<typeof customInstance<HomeResponse>>,) => {
      return customInstance<HomeResponse>(
      {url: `/api/v1/home`, method: 'GET',
        params
    },
      options);
    }

/**
 * Турниры и матчи, добавленные в избранное. Требует авторизации.
 * @summary Избранное пользователя
 */
const getApiV1MeFavorites = (

 options?: SecondParameter<typeof customInstance<HomeFavorites>>,) => {
      return customInstance<HomeFavorites>(
      {url: `/api/v1/me/favorites`, method: 'GET'
    },
      options);
    }

/**
 * @summary Добавить турнир в избранное
 */
const postApiV1MeFavoritesTournamentsTournamentId = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/favorites/tournaments/${tournamentId}`, method: 'POST'
    },
      options);
    }

/**
 * @summary Убрать турнир из избранного
 */
const deleteApiV1MeFavoritesTournamentsTournamentId = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/favorites/tournaments/${tournamentId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Добавить матч в избранное
 */
const postApiV1MeFavoritesMatchesMatchId = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/favorites/matches/${matchId}`, method: 'POST'
    },
      options);
    }

/**
 * @summary Убрать матч из избранного
 */
const deleteApiV1MeFavoritesMatchesMatchId = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/favorites/matches/${matchId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Публичная конфигурация Web Push
 */
const getApiV1ConfigWebPush = (

 options?: SecondParameter<typeof customInstance<WebPushConfig>>,) => {
      return customInstance<WebPushConfig>(
      {url: `/api/v1/config/web-push`, method: 'GET'
    },
      options);
    }

/**
 * @summary Зарегистрировать браузер для push-уведомлений
 */
const postApiV1MePushSubscriptions = (
    pushSubscriptionRequest: PushSubscriptionRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/push-subscriptions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionRequest
    },
      options);
    }

/**
 * @summary Удалить браузерную push-подписку
 */
const deleteApiV1MePushSubscriptions = (
    pushSubscriptionDeleteRequest: PushSubscriptionDeleteRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/push-subscriptions`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: pushSubscriptionDeleteRequest
    },
      options);
    }

/**
 * @summary Настройки уведомлений пользователя
 */
const getApiV1MeNotificationSettings = (

 options?: SecondParameter<typeof customInstance<NotificationSettings>>,) => {
      return customInstance<NotificationSettings>(
      {url: `/api/v1/me/notification-settings`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить настройки уведомлений пользователя
 */
const patchApiV1MeNotificationSettings = (
    notificationSettings: NotificationSettings,
 options?: SecondParameter<typeof customInstance<NotificationSettings>>,) => {
      return customInstance<NotificationSettings>(
      {url: `/api/v1/me/notification-settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: notificationSettings
    },
      options);
    }

/**
 * @summary Начать вход по email (OTP + magic-link)
 */
const postApiV1AuthEmailStart = (
    authEmailRequest: AuthEmailRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/auth/email/start`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authEmailRequest
    },
      options);
    }

/**
 * @summary Подтвердить email по коду или magic-link токену
 */
const postApiV1AuthEmailConfirm = (
    authEmailConfirmRequest: AuthEmailConfirmRequest,
 options?: SecondParameter<typeof customInstance<AuthEmailConfirmResponse>>,) => {
      return customInstance<AuthEmailConfirmResponse>(
      {url: `/api/v1/auth/email/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authEmailConfirmRequest
    },
      options);
    }

/**
 * @summary Dev-only вход по email без OTP
 */
const postApiV1AuthDevLogin = (
    authEmailRequest: AuthEmailRequest,
 options?: SecondParameter<typeof customInstance<AuthTokensResponse>>,) => {
      return customInstance<AuthTokensResponse>(
      {url: `/api/v1/auth/dev/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authEmailRequest
    },
      options);
    }

/**
 * @summary Начать WebAuthn login
 */
const postApiV1AuthWebauthnLoginBegin = (
    authWebAuthnLoginBeginRequest: AuthWebAuthnLoginBeginRequest,
 options?: SecondParameter<typeof customInstance<AuthWebAuthnOptions>>,) => {
      return customInstance<AuthWebAuthnOptions>(
      {url: `/api/v1/auth/webauthn/login/begin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authWebAuthnLoginBeginRequest
    },
      options);
    }

/**
 * @summary Завершить WebAuthn login
 */
const postApiV1AuthWebauthnLoginFinish = (
    authWebAuthnFinishRequest: AuthWebAuthnFinishRequest,
 options?: SecondParameter<typeof customInstance<AuthTokensResponse>>,) => {
      return customInstance<AuthTokensResponse>(
      {url: `/api/v1/auth/webauthn/login/finish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authWebAuthnFinishRequest
    },
      options);
    }

/**
 * @summary Начать регистрацию Passkey
 */
const postApiV1AuthWebauthnRegisterBegin = (
    postApiV1AuthWebauthnRegisterBeginBody: PostApiV1AuthWebauthnRegisterBeginBody,
 options?: SecondParameter<typeof customInstance<AuthWebAuthnOptions>>,) => {
      return customInstance<AuthWebAuthnOptions>(
      {url: `/api/v1/auth/webauthn/register/begin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV1AuthWebauthnRegisterBeginBody
    },
      options);
    }

/**
 * @summary Сохранить Passkey
 */
const postApiV1AuthWebauthnRegisterFinish = (
    authWebAuthnFinishRequest: AuthWebAuthnFinishRequest,
 options?: SecondParameter<typeof customInstance<AuthWebAuthnCredential>>,) => {
      return customInstance<AuthWebAuthnCredential>(
      {url: `/api/v1/auth/webauthn/register/finish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authWebAuthnFinishRequest
    },
      options);
    }

/**
 * @summary Список Passkeys
 */
const getApiV1AuthWebauthnCredentials = (

 options?: SecondParameter<typeof customInstance<AuthWebAuthnCredential[]>>,) => {
      return customInstance<AuthWebAuthnCredential[]>(
      {url: `/api/v1/auth/webauthn/credentials`, method: 'GET'
    },
      options);
    }

/**
 * @summary Переименовать Passkey
 */
const patchApiV1AuthWebauthnCredentialsCredentialId = (
    credentialId: string,
    authWebAuthnCredentialRename: AuthWebAuthnCredentialRename,
 options?: SecondParameter<typeof customInstance<AuthWebAuthnCredential>>,) => {
      return customInstance<AuthWebAuthnCredential>(
      {url: `/api/v1/auth/webauthn/credentials/${credentialId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: authWebAuthnCredentialRename
    },
      options);
    }

/**
 * @summary Удалить Passkey
 */
const deleteApiV1AuthWebauthnCredentialsCredentialId = (
    credentialId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/auth/webauthn/credentials/${credentialId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Обновить access token по refresh token
 */
const postApiV1AuthRefresh = (
    authRefreshRequest: AuthRefreshRequest,
 options?: SecondParameter<typeof customInstance<AuthTokensResponse>>,) => {
      return customInstance<AuthTokensResponse>(
      {url: `/api/v1/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authRefreshRequest
    },
      options);
    }

/**
 * @summary Выход из сессии
 */
const postApiV1AuthLogout = (
    authLogoutRequest: AuthLogoutRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/auth/logout`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: authLogoutRequest
    },
      options);
    }

/**
 * @summary Список поддерживаемых видов спорта
 */
const getApiV1Sports = (

 options?: SecondParameter<typeof customInstance<Sport[]>>,) => {
      return customInstance<Sport[]>(
      {url: `/api/v1/sports`, method: 'GET'
    },
      options);
    }

/**
 * @summary Создать вид спорта
 */
const postApiV1Sports = (
    sportCreate: SportCreate,
 options?: SecondParameter<typeof customInstance<Sport>>,) => {
      return customInstance<Sport>(
      {url: `/api/v1/sports`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sportCreate
    },
      options);
    }

/**
 * @summary Получить вид спорта
 */
const getApiV1SportsSportId = (
    sportId: string,
 options?: SecondParameter<typeof customInstance<Sport>>,) => {
      return customInstance<Sport>(
      {url: `/api/v1/sports/${sportId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить вид спорта
 */
const patchApiV1SportsSportId = (
    sportId: string,
    sportUpdate: SportUpdate,
 options?: SecondParameter<typeof customInstance<Sport>>,) => {
      return customInstance<Sport>(
      {url: `/api/v1/sports/${sportId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: sportUpdate
    },
      options);
    }

/**
 * @summary Удалить вид спорта
 */
const deleteApiV1SportsSportId = (
    sportId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/sports/${sportId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить вид спорта
 */
const postApiV1SportsSportIdRestore = (
    sportId: string,
 options?: SecondParameter<typeof customInstance<Sport>>,) => {
      return customInstance<Sport>(
      {url: `/api/v1/sports/${sportId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * @summary Список организаций
 */
const getApiV1Organizations = (
    params?: GetApiV1OrganizationsParams,
 options?: SecondParameter<typeof customInstance<PaginatedOrganizationsResponse>>,) => {
      return customInstance<PaginatedOrganizationsResponse>(
      {url: `/api/v1/organizations`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Создать организацию
 */
const postApiV1Organizations = (
    organizationCreate: OrganizationCreate,
 options?: SecondParameter<typeof customInstance<Organization>>,) => {
      return customInstance<Organization>(
      {url: `/api/v1/organizations`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organizationCreate
    },
      options);
    }

/**
 * @summary Получить организацию
 */
const getApiV1OrganizationsOrganizationId = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance<Organization>>,) => {
      return customInstance<Organization>(
      {url: `/api/v1/organizations/${organizationId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить организацию
 */
const patchApiV1OrganizationsOrganizationId = (
    organizationId: string,
    organizationUpdate: OrganizationUpdate,
 options?: SecondParameter<typeof customInstance<Organization>>,) => {
      return customInstance<Organization>(
      {url: `/api/v1/organizations/${organizationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: organizationUpdate
    },
      options);
    }

/**
 * @summary Удалить организацию
 */
const deleteApiV1OrganizationsOrganizationId = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/organizations/${organizationId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить организацию
 */
const postApiV1OrganizationsOrganizationIdRestore = (
    organizationId: string,
 options?: SecondParameter<typeof customInstance<Organization>>,) => {
      return customInstance<Organization>(
      {url: `/api/v1/organizations/${organizationId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * Турниры конкретной организации с фильтрацией по сезону, виду спорта и статусу.
 * @summary Список турниров организации
 */
const getApiV1OrganizationsOrganizationIdTournaments = (
    organizationId: string,
    params?: GetApiV1OrganizationsOrganizationIdTournamentsParams,
 options?: SecondParameter<typeof customInstance<PaginatedTournamentsResponse>>,) => {
      return customInstance<PaginatedTournamentsResponse>(
      {url: `/api/v1/organizations/${organizationId}/tournaments`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Список арен
 */
const getApiV1Venues = (
    params?: GetApiV1VenuesParams,
 options?: SecondParameter<typeof customInstance<PaginatedVenuesResponse>>,) => {
      return customInstance<PaginatedVenuesResponse>(
      {url: `/api/v1/venues`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Создать арену
 */
const postApiV1Venues = (
    venueCreate: VenueCreate,
 options?: SecondParameter<typeof customInstance<Venue>>,) => {
      return customInstance<Venue>(
      {url: `/api/v1/venues`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: venueCreate
    },
      options);
    }

/**
 * @summary Получить арену
 */
const getApiV1VenuesVenueId = (
    venueId: string,
 options?: SecondParameter<typeof customInstance<Venue>>,) => {
      return customInstance<Venue>(
      {url: `/api/v1/venues/${venueId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить арену
 */
const patchApiV1VenuesVenueId = (
    venueId: string,
    venueUpdate: VenueUpdate,
 options?: SecondParameter<typeof customInstance<Venue>>,) => {
      return customInstance<Venue>(
      {url: `/api/v1/venues/${venueId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: venueUpdate
    },
      options);
    }

/**
 * @summary Удалить арену
 */
const deleteApiV1VenuesVenueId = (
    venueId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/venues/${venueId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить арену
 */
const postApiV1VenuesVenueIdRestore = (
    venueId: string,
 options?: SecondParameter<typeof customInstance<Venue>>,) => {
      return customInstance<Venue>(
      {url: `/api/v1/venues/${venueId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * @summary Список команд
 */
const getApiV1Teams = (
    params?: GetApiV1TeamsParams,
 options?: SecondParameter<typeof customInstance<PaginatedTeamsResponse>>,) => {
      return customInstance<PaginatedTeamsResponse>(
      {url: `/api/v1/teams`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Создать команду
 */
const postApiV1Teams = (
    teamCreate: TeamCreate,
 options?: SecondParameter<typeof customInstance<Team>>,) => {
      return customInstance<Team>(
      {url: `/api/v1/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: teamCreate
    },
      options);
    }

/**
 * @summary Получить команду
 */
const getApiV1TeamsTeamId = (
    teamId: string,
 options?: SecondParameter<typeof customInstance<Team>>,) => {
      return customInstance<Team>(
      {url: `/api/v1/teams/${teamId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить команду
 */
const patchApiV1TeamsTeamId = (
    teamId: string,
    teamUpdate: TeamUpdate,
 options?: SecondParameter<typeof customInstance<Team>>,) => {
      return customInstance<Team>(
      {url: `/api/v1/teams/${teamId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: teamUpdate
    },
      options);
    }

/**
 * @summary Удалить команду
 */
const deleteApiV1TeamsTeamId = (
    teamId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/teams/${teamId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить команду
 */
const postApiV1TeamsTeamIdRestore = (
    teamId: string,
 options?: SecondParameter<typeof customInstance<Team>>,) => {
      return customInstance<Team>(
      {url: `/api/v1/teams/${teamId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * @summary Список игроков
 */
const getApiV1Players = (
    params?: GetApiV1PlayersParams,
 options?: SecondParameter<typeof customInstance<PaginatedPlayersResponse>>,) => {
      return customInstance<PaginatedPlayersResponse>(
      {url: `/api/v1/players`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Создать игрока
 */
const postApiV1Players = (
    playerCreate: PlayerCreate,
 options?: SecondParameter<typeof customInstance<Player>>,) => {
      return customInstance<Player>(
      {url: `/api/v1/players`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: playerCreate
    },
      options);
    }

/**
 * @summary Получить игрока
 */
const getApiV1PlayersPlayerId = (
    playerId: string,
 options?: SecondParameter<typeof customInstance<Player>>,) => {
      return customInstance<Player>(
      {url: `/api/v1/players/${playerId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить игрока
 */
const patchApiV1PlayersPlayerId = (
    playerId: string,
    playerUpdate: PlayerUpdate,
 options?: SecondParameter<typeof customInstance<Player>>,) => {
      return customInstance<Player>(
      {url: `/api/v1/players/${playerId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: playerUpdate
    },
      options);
    }

/**
 * @summary Удалить игрока
 */
const deleteApiV1PlayersPlayerId = (
    playerId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/players/${playerId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить игрока
 */
const postApiV1PlayersPlayerIdRestore = (
    playerId: string,
 options?: SecondParameter<typeof customInstance<Player>>,) => {
      return customInstance<Player>(
      {url: `/api/v1/players/${playerId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * @summary Список официальных лиц
 */
const getApiV1Officials = (
    params?: GetApiV1OfficialsParams,
 options?: SecondParameter<typeof customInstance<PaginatedOfficialsResponse>>,) => {
      return customInstance<PaginatedOfficialsResponse>(
      {url: `/api/v1/officials`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Создать официальное лицо
 */
const postApiV1Officials = (
    officialCreate: OfficialCreate,
 options?: SecondParameter<typeof customInstance<Official>>,) => {
      return customInstance<Official>(
      {url: `/api/v1/officials`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: officialCreate
    },
      options);
    }

/**
 * @summary Получить официальное лицо
 */
const getApiV1OfficialsOfficialId = (
    officialId: string,
 options?: SecondParameter<typeof customInstance<Official>>,) => {
      return customInstance<Official>(
      {url: `/api/v1/officials/${officialId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить официальное лицо
 */
const patchApiV1OfficialsOfficialId = (
    officialId: string,
    officialUpdate: OfficialUpdate,
 options?: SecondParameter<typeof customInstance<Official>>,) => {
      return customInstance<Official>(
      {url: `/api/v1/officials/${officialId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: officialUpdate
    },
      options);
    }

/**
 * @summary Удалить официальное лицо
 */
const deleteApiV1OfficialsOfficialId = (
    officialId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/officials/${officialId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить официальное лицо
 */
const postApiV1OfficialsOfficialIdRestore = (
    officialId: string,
 options?: SecondParameter<typeof customInstance<Official>>,) => {
      return customInstance<Official>(
      {url: `/api/v1/officials/${officialId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * Глобальный список турниров с фильтрацией по организации, сезону, виду спорта и статусу.
 * @summary Список турниров
 */
const getApiV1Tournaments = (
    params?: GetApiV1TournamentsParams,
 options?: SecondParameter<typeof customInstance<PaginatedTournamentsResponse>>,) => {
      return customInstance<PaginatedTournamentsResponse>(
      {url: `/api/v1/tournaments`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Создать турнир
 */
const postApiV1Tournaments = (
    tournamentCreate: TournamentCreate,
 options?: SecondParameter<typeof customInstance<Tournament>>,) => {
      return customInstance<Tournament>(
      {url: `/api/v1/tournaments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tournamentCreate
    },
      options);
    }

/**
 * @summary Получить турнир
 */
const getApiV1TournamentsTournamentId = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<Tournament>>,) => {
      return customInstance<Tournament>(
      {url: `/api/v1/tournaments/${tournamentId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить турнир
 */
const patchApiV1TournamentsTournamentId = (
    tournamentId: string,
    tournamentUpdate: TournamentUpdate,
 options?: SecondParameter<typeof customInstance<Tournament>>,) => {
      return customInstance<Tournament>(
      {url: `/api/v1/tournaments/${tournamentId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tournamentUpdate
    },
      options);
    }

/**
 * @summary Удалить турнир
 */
const deleteApiV1TournamentsTournamentId = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tournaments/${tournamentId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить турнир
 */
const postApiV1TournamentsTournamentIdRestore = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<Tournament>>,) => {
      return customInstance<Tournament>(
      {url: `/api/v1/tournaments/${tournamentId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * @summary Опубликовать турнир
 */
const postApiV1TournamentsTournamentIdPublish = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tournaments/${tournamentId}/publish`, method: 'POST'
    },
      options);
    }

/**
 * @summary Стартовать турнир
 */
const postApiV1TournamentsTournamentIdStart = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tournaments/${tournamentId}/start`, method: 'POST'
    },
      options);
    }

/**
 * @summary Завершить турнир
 */
const postApiV1TournamentsTournamentIdComplete = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tournaments/${tournamentId}/complete`, method: 'POST'
    },
      options);
    }

/**
 * @summary Отменить турнир
 */
const postApiV1TournamentsTournamentIdCancel = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tournaments/${tournamentId}/cancel`, method: 'POST'
    },
      options);
    }

/**
 * @summary Регистрация команды/игрока
 */
const postApiV1TournamentsTournamentIdRegister = (
    tournamentId: string,
    registrationCreate: RegistrationCreate,
 options?: SecondParameter<typeof customInstance<Registration>>,) => {
      return customInstance<Registration>(
      {url: `/api/v1/tournaments/${tournamentId}/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registrationCreate
    },
      options);
    }

/**
 * @summary Список регистраций
 */
const getApiV1Registrations = (
    params?: GetApiV1RegistrationsParams,
 options?: SecondParameter<typeof customInstance<PaginatedRegistrationsResponse>>,) => {
      return customInstance<PaginatedRegistrationsResponse>(
      {url: `/api/v1/registrations`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Получить регистрацию
 */
const getApiV1RegistrationsRegistrationId = (
    registrationId: string,
 options?: SecondParameter<typeof customInstance<Registration>>,) => {
      return customInstance<Registration>(
      {url: `/api/v1/registrations/${registrationId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить регистрацию
 */
const patchApiV1RegistrationsRegistrationId = (
    registrationId: string,
    registrationUpdate: RegistrationUpdate,
 options?: SecondParameter<typeof customInstance<Registration>>,) => {
      return customInstance<Registration>(
      {url: `/api/v1/registrations/${registrationId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: registrationUpdate
    },
      options);
    }

/**
 * @summary Удалить регистрацию
 */
const deleteApiV1RegistrationsRegistrationId = (
    registrationId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/registrations/${registrationId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Восстановить регистрацию
 */
const postApiV1RegistrationsRegistrationIdRestore = (
    registrationId: string,
 options?: SecondParameter<typeof customInstance<Registration>>,) => {
      return customInstance<Registration>(
      {url: `/api/v1/registrations/${registrationId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * @summary Список регистраций турнира
 */
const getApiV1TournamentsTournamentIdRegistrations = (
    tournamentId: string,
    params?: GetApiV1TournamentsTournamentIdRegistrationsParams,
 options?: SecondParameter<typeof customInstance<PaginatedRegistrationsResponse>>,) => {
      return customInstance<PaginatedRegistrationsResponse>(
      {url: `/api/v1/tournaments/${tournamentId}/registrations`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Посев участников (seeding)
 */
const postApiV1TournamentsTournamentIdSeed = (
    tournamentId: string,
    postApiV1TournamentsTournamentIdSeedBody?: PostApiV1TournamentsTournamentIdSeedBody,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/tournaments/${tournamentId}/seed`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiV1TournamentsTournamentIdSeedBody
    },
      options);
    }

/**
 * @summary Таблица/рейтинги
 */
const getApiV1TournamentsTournamentIdStandings = (
    tournamentId: string,
    params?: GetApiV1TournamentsTournamentIdStandingsParams,
 options?: SecondParameter<typeof customInstance<StandingTable>>,) => {
      return customInstance<StandingTable>(
      {url: `/api/v1/tournaments/${tournamentId}/standings`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Список стадий турнира
 */
const getApiV1TournamentsTournamentIdStages = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<TournamentStage[]>>,) => {
      return customInstance<TournamentStage[]>(
      {url: `/api/v1/tournaments/${tournamentId}/stages`, method: 'GET'
    },
      options);
    }

/**
 * @summary Создать стадию турнира
 */
const postApiV1TournamentsTournamentIdStages = (
    tournamentId: string,
    tournamentStageCreate: TournamentStageCreate,
 options?: SecondParameter<typeof customInstance<TournamentStage>>,) => {
      return customInstance<TournamentStage>(
      {url: `/api/v1/tournaments/${tournamentId}/stages`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tournamentStageCreate
    },
      options);
    }

/**
 * @summary Получить стадию турнира
 */
const getApiV1TournamentsTournamentIdStagesStageId = (
    tournamentId: string,
    stageId: string,
 options?: SecondParameter<typeof customInstance<TournamentStage>>,) => {
      return customInstance<TournamentStage>(
      {url: `/api/v1/tournaments/${tournamentId}/stages/${stageId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить стадию турнира
 */
const patchApiV1TournamentsTournamentIdStagesStageId = (
    tournamentId: string,
    stageId: string,
    tournamentStageUpdate: TournamentStageUpdate,
 options?: SecondParameter<typeof customInstance<TournamentStage>>,) => {
      return customInstance<TournamentStage>(
      {url: `/api/v1/tournaments/${tournamentId}/stages/${stageId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: tournamentStageUpdate
    },
      options);
    }

/**
 * @summary Таблица результатов по стадии
 */
const getApiV1TournamentsTournamentIdStagesStageIdStandings = (
    tournamentId: string,
    stageId: string,
 options?: SecondParameter<typeof customInstance<StageStandingTable>>,) => {
      return customInstance<StageStandingTable>(
      {url: `/api/v1/tournaments/${tournamentId}/stages/${stageId}/standings`, method: 'GET'
    },
      options);
    }

/**
 * @summary Генерация расписания для стадии
 */
const postApiV1TournamentsTournamentIdStagesStageIdGenerateSchedule = (
    tournamentId: string,
    stageId: string,
    scheduleGenerationRequest?: ScheduleGenerationRequest,
 options?: SecondParameter<typeof customInstance<ScheduleGenerationResponse>>,) => {
      return customInstance<ScheduleGenerationResponse>(
      {url: `/api/v1/tournaments/${tournamentId}/stages/${stageId}/generate-schedule`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleGenerationRequest
    },
      options);
    }

/**
 * @summary Предпросмотр расписания стадии без сохранения
 */
const postApiV1TournamentsTournamentIdStagesStageIdSchedulePreview = (
    tournamentId: string,
    stageId: string,
    scheduleGenerationRequest?: ScheduleGenerationRequest,
 options?: SecondParameter<typeof customInstance<SchedulePreviewResponse>>,) => {
      return customInstance<SchedulePreviewResponse>(
      {url: `/api/v1/tournaments/${tournamentId}/stages/${stageId}/schedule-preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleGenerationRequest
    },
      options);
    }

/**
 * @summary Сохранить расписание стадии из предпросмотра
 */
const postApiV1TournamentsTournamentIdStagesStageIdScheduleSave = (
    tournamentId: string,
    stageId: string,
    scheduleSaveRequest: ScheduleSaveRequest,
 options?: SecondParameter<typeof customInstance<ScheduleGenerationResponse>>,) => {
      return customInstance<ScheduleGenerationResponse>(
      {url: `/api/v1/tournaments/${tournamentId}/stages/${stageId}/schedule-save`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scheduleSaveRequest
    },
      options);
    }

/**
 * @summary Применить автопереходы на следующую стадию
 */
const postApiV1TournamentsTournamentIdStagesStageIdTransitionsApply = (
    tournamentId: string,
    stageId: string,
 options?: SecondParameter<typeof customInstance<StageStandingTable>>,) => {
      return customInstance<StageStandingTable>(
      {url: `/api/v1/tournaments/${tournamentId}/stages/${stageId}/transitions/apply`, method: 'POST'
    },
      options);
    }

/**
 * @summary Сетка плей-офф
 */
const getApiV1TournamentsTournamentIdBracket = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<Bracket>>,) => {
      return customInstance<Bracket>(
      {url: `/api/v1/tournaments/${tournamentId}/bracket`, method: 'GET'
    },
      options);
    }

/**
 * @summary Список матчей турнира
 */
const getApiV1TournamentsTournamentIdMatches = (
    tournamentId: string,
    params?: GetApiV1TournamentsTournamentIdMatchesParams,
 options?: SecondParameter<typeof customInstance<PaginatedMatchesResponse>>,) => {
      return customInstance<PaginatedMatchesResponse>(
      {url: `/api/v1/tournaments/${tournamentId}/matches`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Создать матч в турнире
 */
const postApiV1TournamentsTournamentIdMatches = (
    tournamentId: string,
    matchCreate: MatchCreate,
 options?: SecondParameter<typeof customInstance<Match>>,) => {
      return customInstance<Match>(
      {url: `/api/v1/tournaments/${tournamentId}/matches`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchCreate
    },
      options);
    }

/**
 * @summary Список матчей
 */
const getApiV1Matches = (
    params?: GetApiV1MatchesParams,
 options?: SecondParameter<typeof customInstance<PaginatedMatchesResponse>>,) => {
      return customInstance<PaginatedMatchesResponse>(
      {url: `/api/v1/matches`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Получить матч
 */
const getApiV1MatchesMatchId = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<Match>>,) => {
      return customInstance<Match>(
      {url: `/api/v1/matches/${matchId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Удалить матч
 */
const deleteApiV1MatchesMatchId = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/matches/${matchId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Обновить детали матча
 */
const patchApiV1MatchesMatchId = (
    matchId: string,
    matchUpdate: MatchUpdate,
 options?: SecondParameter<typeof customInstance<Match>>,) => {
      return customInstance<Match>(
      {url: `/api/v1/matches/${matchId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: matchUpdate
    },
      options);
    }

/**
 * @summary Восстановить матч
 */
const postApiV1MatchesMatchIdRestore = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<Match>>,) => {
      return customInstance<Match>(
      {url: `/api/v1/matches/${matchId}/restore`, method: 'POST'
    },
      options);
    }

/**
 * @summary Список событий матча
 */
const getApiV1MatchesMatchIdEvents = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<MatchEventList>>,) => {
      return customInstance<MatchEventList>(
      {url: `/api/v1/matches/${matchId}/events`, method: 'GET'
    },
      options);
    }

/**
 * @summary Добавить событие матча (гол, карточка, очко, фол)
 */
const postApiV1MatchesMatchIdEvents = (
    matchId: string,
    matchEventCreate: MatchEventCreate,
 options?: SecondParameter<typeof customInstance<MatchEvent>>,) => {
      return customInstance<MatchEvent>(
      {url: `/api/v1/matches/${matchId}/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchEventCreate
    },
      options);
    }

/**
 * @summary Получить событие матча
 */
const getApiV1MatchesMatchIdEventsEventId = (
    matchId: string,
    eventId: string,
 options?: SecondParameter<typeof customInstance<MatchEvent>>,) => {
      return customInstance<MatchEvent>(
      {url: `/api/v1/matches/${matchId}/events/${eventId}`, method: 'GET'
    },
      options);
    }

/**
 * @summary Обновить событие матча
 */
const patchApiV1MatchesMatchIdEventsEventId = (
    matchId: string,
    eventId: string,
    matchEventUpdate: MatchEventUpdate,
 options?: SecondParameter<typeof customInstance<MatchEvent>>,) => {
      return customInstance<MatchEvent>(
      {url: `/api/v1/matches/${matchId}/events/${eventId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: matchEventUpdate
    },
      options);
    }

/**
 * @summary Удалить событие матча
 */
const deleteApiV1MatchesMatchIdEventsEventId = (
    matchId: string,
    eventId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/matches/${matchId}/events/${eventId}`, method: 'DELETE'
    },
      options);
    }

/**
 * @summary Предварительный результат
 */
const postApiV1MatchesMatchIdReportResult = (
    matchId: string,
    matchResultReport: MatchResultReport,
 options?: SecondParameter<typeof customInstance<Match>>,) => {
      return customInstance<Match>(
      {url: `/api/v1/matches/${matchId}/report-result`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: matchResultReport
    },
      options);
    }

/**
 * @summary Подтверждение результата судьёй
 */
const postApiV1MatchesMatchIdConfirmResult = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<Match>>,) => {
      return customInstance<Match>(
      {url: `/api/v1/matches/${matchId}/confirm-result`, method: 'POST'
    },
      options);
    }

/**
 * @summary Итоговые результаты турнира
 */
const getApiV1TournamentsTournamentIdResults = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<TournamentResults>>,) => {
      return customInstance<TournamentResults>(
      {url: `/api/v1/tournaments/${tournamentId}/results`, method: 'GET'
    },
      options);
    }

/**
 * @summary Статистика игроков в рамках турнира
 */
const getApiV1TournamentsTournamentIdPlayerStats = (
    tournamentId: string,
    params?: GetApiV1TournamentsTournamentIdPlayerStatsParams,
 options?: SecondParameter<typeof customInstance<PaginatedPlayerStatsList>>,) => {
      return customInstance<PaginatedPlayerStatsList>(
      {url: `/api/v1/tournaments/${tournamentId}/player-stats`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Лидерборды игроков по метрикам турнира
 */
const getApiV1TournamentsTournamentIdLeaderboardsPlayers = (
    tournamentId: string,
    params: GetApiV1TournamentsTournamentIdLeaderboardsPlayersParams,
 options?: SecondParameter<typeof customInstance<LeaderboardPlayers>>,) => {
      return customInstance<LeaderboardPlayers>(
      {url: `/api/v1/tournaments/${tournamentId}/leaderboards/players`, method: 'GET',
        params
    },
      options);
    }

/**
 * @summary Статистика игрока (карьера/сезон/турнир)
 */
const getApiV1PlayersPlayerIdStats = (
    playerId: string,
    params?: GetApiV1PlayersPlayerIdStatsParams,
 options?: SecondParameter<typeof customInstance<PlayerStatsSummary>>,) => {
      return customInstance<PlayerStatsSummary>(
      {url: `/api/v1/players/${playerId}/stats`, method: 'GET',
        params
    },
      options);
    }

/**
 * Агрегат для режима «Админ»: флаги создания, «Требует внимания», «Сегодня я веду», «Мои ресурсы».
Без Bearer возвращает canManageAnything=false и пустые списки.
Права считает та же функция, что авторизует запись.

 * @summary Всё, что связано с управлением для текущего пользователя
 */
const getApiV1Manager = (

 options?: SecondParameter<typeof customInstance<ManagerResponse>>,) => {
      return customInstance<ManagerResponse>(
      {url: `/api/v1/manager`, method: 'GET'
    },
      options);
    }

/**
 * @summary Игрок, связанный с текущим пользователем
 */
const getApiV1MePlayer = (

 options?: SecondParameter<typeof customInstance<MePlayer>>,) => {
      return customInstance<MePlayer>(
      {url: `/api/v1/me/player`, method: 'GET'
    },
      options);
    }

/**
 * @summary Пресеты турниров с описанием полей формы
 */
const getApiV1TournamentPresets = (
    params?: GetApiV1TournamentPresetsParams,
 options?: SecondParameter<typeof customInstance<TournamentPreset[]>>,) => {
      return customInstance<TournamentPreset[]>(
      {url: `/api/v1/tournament-presets`, method: 'GET',
        params
    },
      options);
    }

/**
 * Тело — значения полей пресета (`fields[].key`). Ошибки валидации — 422 `{ fieldErrors }`.
 * @summary Создать турнир из пресета
 */
const postApiV1TournamentPresetsPresetIdCreate = (
    presetId: string,
    fieldValues: FieldValues,
 options?: SecondParameter<typeof customInstance<Tournament>>,) => {
      return customInstance<Tournament>(
      {url: `/api/v1/tournament-presets/${presetId}/create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fieldValues
    },
      options);
    }

/**
 * @summary Форма настроек турнира (поля с текущими значениями)
 */
const getApiV1TournamentsTournamentIdSettingsForm = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<SettingsForm>>,) => {
      return customInstance<SettingsForm>(
      {url: `/api/v1/tournaments/${tournamentId}/settings-form`, method: 'GET'
    },
      options);
    }

/**
 * Ошибки валидации — 422 `{ fieldErrors }`.
 * @summary Сохранить форму настроек турнира
 */
const patchApiV1TournamentsTournamentIdSettingsForm = (
    tournamentId: string,
    fieldValues: FieldValues,
 options?: SecondParameter<typeof customInstance<Tournament>>,) => {
      return customInstance<Tournament>(
      {url: `/api/v1/tournaments/${tournamentId}/settings-form`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fieldValues
    },
      options);
    }

/**
 * Фазы, чек-листы, действия и панели. Фронт рендерит без знания правил турнира.
 * @summary Сценарий ведения турнира (BDUI)
 */
const getApiV1TournamentsTournamentIdWorkflow = (
    tournamentId: string,
 options?: SecondParameter<typeof customInstance<TournamentWorkflow>>,) => {
      return customInstance<TournamentWorkflow>(
      {url: `/api/v1/tournaments/${tournamentId}/workflow`, method: 'GET'
    },
      options);
    }

/**
 * Тело — значения `input` действия и его `params`. Сервер перед выполнением прогоняет те же checks.
Действия зрителя (`signup`, `cancel_signup`) доступны любому вошедшему.
Ошибки валидации — 422 `{ fieldErrors }`, запрет — 403.

 * @summary Выполнить действие сценария
 */
const postApiV1TournamentsTournamentIdActionsActionId = (
    tournamentId: string,
    actionId: string,
    fieldValues?: FieldValues,
 options?: SecondParameter<typeof customInstance<ActionResult>>,) => {
      return customInstance<ActionResult>(
      {url: `/api/v1/tournaments/${tournamentId}/actions/${actionId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fieldValues
    },
      options);
    }

/**
 * События, периоды, решающие шаги и составы по правилам турнира.
 * @summary Конфигурация экрана ведения матча
 */
const getApiV1MatchesMatchIdLiveConfig = (
    matchId: string,
 options?: SecondParameter<typeof customInstance<MatchLiveConfig>>,) => {
      return customInstance<MatchLiveConfig>(
      {url: `/api/v1/matches/${matchId}/live-config`, method: 'GET'
    },
      options);
    }

/**
 * @summary Действие ведения матча (start, finish, confirm, correct_result)
 */
const postApiV1MatchesMatchIdActionsActionId = (
    matchId: string,
    actionId: string,
    fieldValues?: FieldValues,
 options?: SecondParameter<typeof customInstance<Match>>,) => {
      return customInstance<Match>(
      {url: `/api/v1/matches/${matchId}/actions/${actionId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fieldValues
    },
      options);
    }

return {getApiV1Home,getApiV1MeFavorites,postApiV1MeFavoritesTournamentsTournamentId,deleteApiV1MeFavoritesTournamentsTournamentId,postApiV1MeFavoritesMatchesMatchId,deleteApiV1MeFavoritesMatchesMatchId,getApiV1ConfigWebPush,postApiV1MePushSubscriptions,deleteApiV1MePushSubscriptions,getApiV1MeNotificationSettings,patchApiV1MeNotificationSettings,postApiV1AuthEmailStart,postApiV1AuthEmailConfirm,postApiV1AuthDevLogin,postApiV1AuthWebauthnLoginBegin,postApiV1AuthWebauthnLoginFinish,postApiV1AuthWebauthnRegisterBegin,postApiV1AuthWebauthnRegisterFinish,getApiV1AuthWebauthnCredentials,patchApiV1AuthWebauthnCredentialsCredentialId,deleteApiV1AuthWebauthnCredentialsCredentialId,postApiV1AuthRefresh,postApiV1AuthLogout,getApiV1Sports,postApiV1Sports,getApiV1SportsSportId,patchApiV1SportsSportId,deleteApiV1SportsSportId,postApiV1SportsSportIdRestore,getApiV1Organizations,postApiV1Organizations,getApiV1OrganizationsOrganizationId,patchApiV1OrganizationsOrganizationId,deleteApiV1OrganizationsOrganizationId,postApiV1OrganizationsOrganizationIdRestore,getApiV1OrganizationsOrganizationIdTournaments,getApiV1Venues,postApiV1Venues,getApiV1VenuesVenueId,patchApiV1VenuesVenueId,deleteApiV1VenuesVenueId,postApiV1VenuesVenueIdRestore,getApiV1Teams,postApiV1Teams,getApiV1TeamsTeamId,patchApiV1TeamsTeamId,deleteApiV1TeamsTeamId,postApiV1TeamsTeamIdRestore,getApiV1Players,postApiV1Players,getApiV1PlayersPlayerId,patchApiV1PlayersPlayerId,deleteApiV1PlayersPlayerId,postApiV1PlayersPlayerIdRestore,getApiV1Officials,postApiV1Officials,getApiV1OfficialsOfficialId,patchApiV1OfficialsOfficialId,deleteApiV1OfficialsOfficialId,postApiV1OfficialsOfficialIdRestore,getApiV1Tournaments,postApiV1Tournaments,getApiV1TournamentsTournamentId,patchApiV1TournamentsTournamentId,deleteApiV1TournamentsTournamentId,postApiV1TournamentsTournamentIdRestore,postApiV1TournamentsTournamentIdPublish,postApiV1TournamentsTournamentIdStart,postApiV1TournamentsTournamentIdComplete,postApiV1TournamentsTournamentIdCancel,postApiV1TournamentsTournamentIdRegister,getApiV1Registrations,getApiV1RegistrationsRegistrationId,patchApiV1RegistrationsRegistrationId,deleteApiV1RegistrationsRegistrationId,postApiV1RegistrationsRegistrationIdRestore,getApiV1TournamentsTournamentIdRegistrations,postApiV1TournamentsTournamentIdSeed,getApiV1TournamentsTournamentIdStandings,getApiV1TournamentsTournamentIdStages,postApiV1TournamentsTournamentIdStages,getApiV1TournamentsTournamentIdStagesStageId,patchApiV1TournamentsTournamentIdStagesStageId,getApiV1TournamentsTournamentIdStagesStageIdStandings,postApiV1TournamentsTournamentIdStagesStageIdGenerateSchedule,postApiV1TournamentsTournamentIdStagesStageIdSchedulePreview,postApiV1TournamentsTournamentIdStagesStageIdScheduleSave,postApiV1TournamentsTournamentIdStagesStageIdTransitionsApply,getApiV1TournamentsTournamentIdBracket,getApiV1TournamentsTournamentIdMatches,postApiV1TournamentsTournamentIdMatches,getApiV1Matches,getApiV1MatchesMatchId,deleteApiV1MatchesMatchId,patchApiV1MatchesMatchId,postApiV1MatchesMatchIdRestore,getApiV1MatchesMatchIdEvents,postApiV1MatchesMatchIdEvents,getApiV1MatchesMatchIdEventsEventId,patchApiV1MatchesMatchIdEventsEventId,deleteApiV1MatchesMatchIdEventsEventId,postApiV1MatchesMatchIdReportResult,postApiV1MatchesMatchIdConfirmResult,getApiV1TournamentsTournamentIdResults,getApiV1TournamentsTournamentIdPlayerStats,getApiV1TournamentsTournamentIdLeaderboardsPlayers,getApiV1PlayersPlayerIdStats,getApiV1Manager,getApiV1MePlayer,getApiV1TournamentPresets,postApiV1TournamentPresetsPresetIdCreate,getApiV1TournamentsTournamentIdSettingsForm,patchApiV1TournamentsTournamentIdSettingsForm,getApiV1TournamentsTournamentIdWorkflow,postApiV1TournamentsTournamentIdActionsActionId,getApiV1MatchesMatchIdLiveConfig,postApiV1MatchesMatchIdActionsActionId}};
export type GetApiV1HomeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Home']>>>
export type GetApiV1MeFavoritesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1MeFavorites']>>>
export type PostApiV1MeFavoritesTournamentsTournamentIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MeFavoritesTournamentsTournamentId']>>>
export type DeleteApiV1MeFavoritesTournamentsTournamentIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1MeFavoritesTournamentsTournamentId']>>>
export type PostApiV1MeFavoritesMatchesMatchIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MeFavoritesMatchesMatchId']>>>
export type DeleteApiV1MeFavoritesMatchesMatchIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1MeFavoritesMatchesMatchId']>>>
export type GetApiV1ConfigWebPushResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1ConfigWebPush']>>>
export type PostApiV1MePushSubscriptionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MePushSubscriptions']>>>
export type DeleteApiV1MePushSubscriptionsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1MePushSubscriptions']>>>
export type GetApiV1MeNotificationSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1MeNotificationSettings']>>>
export type PatchApiV1MeNotificationSettingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1MeNotificationSettings']>>>
export type PostApiV1AuthEmailStartResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthEmailStart']>>>
export type PostApiV1AuthEmailConfirmResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthEmailConfirm']>>>
export type PostApiV1AuthDevLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthDevLogin']>>>
export type PostApiV1AuthWebauthnLoginBeginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthWebauthnLoginBegin']>>>
export type PostApiV1AuthWebauthnLoginFinishResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthWebauthnLoginFinish']>>>
export type PostApiV1AuthWebauthnRegisterBeginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthWebauthnRegisterBegin']>>>
export type PostApiV1AuthWebauthnRegisterFinishResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthWebauthnRegisterFinish']>>>
export type GetApiV1AuthWebauthnCredentialsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1AuthWebauthnCredentials']>>>
export type PatchApiV1AuthWebauthnCredentialsCredentialIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1AuthWebauthnCredentialsCredentialId']>>>
export type DeleteApiV1AuthWebauthnCredentialsCredentialIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1AuthWebauthnCredentialsCredentialId']>>>
export type PostApiV1AuthRefreshResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthRefresh']>>>
export type PostApiV1AuthLogoutResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1AuthLogout']>>>
export type GetApiV1SportsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Sports']>>>
export type PostApiV1SportsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1Sports']>>>
export type GetApiV1SportsSportIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1SportsSportId']>>>
export type PatchApiV1SportsSportIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1SportsSportId']>>>
export type DeleteApiV1SportsSportIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1SportsSportId']>>>
export type PostApiV1SportsSportIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1SportsSportIdRestore']>>>
export type GetApiV1OrganizationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Organizations']>>>
export type PostApiV1OrganizationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1Organizations']>>>
export type GetApiV1OrganizationsOrganizationIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1OrganizationsOrganizationId']>>>
export type PatchApiV1OrganizationsOrganizationIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1OrganizationsOrganizationId']>>>
export type DeleteApiV1OrganizationsOrganizationIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1OrganizationsOrganizationId']>>>
export type PostApiV1OrganizationsOrganizationIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1OrganizationsOrganizationIdRestore']>>>
export type GetApiV1OrganizationsOrganizationIdTournamentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1OrganizationsOrganizationIdTournaments']>>>
export type GetApiV1VenuesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Venues']>>>
export type PostApiV1VenuesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1Venues']>>>
export type GetApiV1VenuesVenueIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1VenuesVenueId']>>>
export type PatchApiV1VenuesVenueIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1VenuesVenueId']>>>
export type DeleteApiV1VenuesVenueIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1VenuesVenueId']>>>
export type PostApiV1VenuesVenueIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1VenuesVenueIdRestore']>>>
export type GetApiV1TeamsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Teams']>>>
export type PostApiV1TeamsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1Teams']>>>
export type GetApiV1TeamsTeamIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TeamsTeamId']>>>
export type PatchApiV1TeamsTeamIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1TeamsTeamId']>>>
export type DeleteApiV1TeamsTeamIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1TeamsTeamId']>>>
export type PostApiV1TeamsTeamIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TeamsTeamIdRestore']>>>
export type GetApiV1PlayersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Players']>>>
export type PostApiV1PlayersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1Players']>>>
export type GetApiV1PlayersPlayerIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1PlayersPlayerId']>>>
export type PatchApiV1PlayersPlayerIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1PlayersPlayerId']>>>
export type DeleteApiV1PlayersPlayerIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1PlayersPlayerId']>>>
export type PostApiV1PlayersPlayerIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1PlayersPlayerIdRestore']>>>
export type GetApiV1OfficialsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Officials']>>>
export type PostApiV1OfficialsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1Officials']>>>
export type GetApiV1OfficialsOfficialIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1OfficialsOfficialId']>>>
export type PatchApiV1OfficialsOfficialIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1OfficialsOfficialId']>>>
export type DeleteApiV1OfficialsOfficialIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1OfficialsOfficialId']>>>
export type PostApiV1OfficialsOfficialIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1OfficialsOfficialIdRestore']>>>
export type GetApiV1TournamentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Tournaments']>>>
export type PostApiV1TournamentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1Tournaments']>>>
export type GetApiV1TournamentsTournamentIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentId']>>>
export type PatchApiV1TournamentsTournamentIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1TournamentsTournamentId']>>>
export type DeleteApiV1TournamentsTournamentIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1TournamentsTournamentId']>>>
export type PostApiV1TournamentsTournamentIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdRestore']>>>
export type PostApiV1TournamentsTournamentIdPublishResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdPublish']>>>
export type PostApiV1TournamentsTournamentIdStartResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdStart']>>>
export type PostApiV1TournamentsTournamentIdCompleteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdComplete']>>>
export type PostApiV1TournamentsTournamentIdCancelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdCancel']>>>
export type PostApiV1TournamentsTournamentIdRegisterResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdRegister']>>>
export type GetApiV1RegistrationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Registrations']>>>
export type GetApiV1RegistrationsRegistrationIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1RegistrationsRegistrationId']>>>
export type PatchApiV1RegistrationsRegistrationIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1RegistrationsRegistrationId']>>>
export type DeleteApiV1RegistrationsRegistrationIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1RegistrationsRegistrationId']>>>
export type PostApiV1RegistrationsRegistrationIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1RegistrationsRegistrationIdRestore']>>>
export type GetApiV1TournamentsTournamentIdRegistrationsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdRegistrations']>>>
export type PostApiV1TournamentsTournamentIdSeedResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdSeed']>>>
export type GetApiV1TournamentsTournamentIdStandingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdStandings']>>>
export type GetApiV1TournamentsTournamentIdStagesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdStages']>>>
export type PostApiV1TournamentsTournamentIdStagesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdStages']>>>
export type GetApiV1TournamentsTournamentIdStagesStageIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdStagesStageId']>>>
export type PatchApiV1TournamentsTournamentIdStagesStageIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1TournamentsTournamentIdStagesStageId']>>>
export type GetApiV1TournamentsTournamentIdStagesStageIdStandingsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdStagesStageIdStandings']>>>
export type PostApiV1TournamentsTournamentIdStagesStageIdGenerateScheduleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdStagesStageIdGenerateSchedule']>>>
export type PostApiV1TournamentsTournamentIdStagesStageIdSchedulePreviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdStagesStageIdSchedulePreview']>>>
export type PostApiV1TournamentsTournamentIdStagesStageIdScheduleSaveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdStagesStageIdScheduleSave']>>>
export type PostApiV1TournamentsTournamentIdStagesStageIdTransitionsApplyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdStagesStageIdTransitionsApply']>>>
export type GetApiV1TournamentsTournamentIdBracketResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdBracket']>>>
export type GetApiV1TournamentsTournamentIdMatchesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdMatches']>>>
export type PostApiV1TournamentsTournamentIdMatchesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdMatches']>>>
export type GetApiV1MatchesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Matches']>>>
export type GetApiV1MatchesMatchIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1MatchesMatchId']>>>
export type DeleteApiV1MatchesMatchIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1MatchesMatchId']>>>
export type PatchApiV1MatchesMatchIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1MatchesMatchId']>>>
export type PostApiV1MatchesMatchIdRestoreResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MatchesMatchIdRestore']>>>
export type GetApiV1MatchesMatchIdEventsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1MatchesMatchIdEvents']>>>
export type PostApiV1MatchesMatchIdEventsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MatchesMatchIdEvents']>>>
export type GetApiV1MatchesMatchIdEventsEventIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1MatchesMatchIdEventsEventId']>>>
export type PatchApiV1MatchesMatchIdEventsEventIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1MatchesMatchIdEventsEventId']>>>
export type DeleteApiV1MatchesMatchIdEventsEventIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['deleteApiV1MatchesMatchIdEventsEventId']>>>
export type PostApiV1MatchesMatchIdReportResultResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MatchesMatchIdReportResult']>>>
export type PostApiV1MatchesMatchIdConfirmResultResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MatchesMatchIdConfirmResult']>>>
export type GetApiV1TournamentsTournamentIdResultsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdResults']>>>
export type GetApiV1TournamentsTournamentIdPlayerStatsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdPlayerStats']>>>
export type GetApiV1TournamentsTournamentIdLeaderboardsPlayersResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdLeaderboardsPlayers']>>>
export type GetApiV1PlayersPlayerIdStatsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1PlayersPlayerIdStats']>>>
export type GetApiV1ManagerResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1Manager']>>>
export type GetApiV1MePlayerResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1MePlayer']>>>
export type GetApiV1TournamentPresetsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentPresets']>>>
export type PostApiV1TournamentPresetsPresetIdCreateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentPresetsPresetIdCreate']>>>
export type GetApiV1TournamentsTournamentIdSettingsFormResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdSettingsForm']>>>
export type PatchApiV1TournamentsTournamentIdSettingsFormResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['patchApiV1TournamentsTournamentIdSettingsForm']>>>
export type GetApiV1TournamentsTournamentIdWorkflowResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1TournamentsTournamentIdWorkflow']>>>
export type PostApiV1TournamentsTournamentIdActionsActionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1TournamentsTournamentIdActionsActionId']>>>
export type GetApiV1MatchesMatchIdLiveConfigResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['getApiV1MatchesMatchIdLiveConfig']>>>
export type PostApiV1MatchesMatchIdActionsActionIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get4empAppAPI>['postApiV1MatchesMatchIdActionsActionId']>>>
